import OperatorService from "@/api/services/operator.service";

const ModelsService = {
  getList(params = { search: "", page: 1, count: 10, id_camera: "" }) {
    return OperatorService.get(`/cameras/models`, { headers: params });
  },
  
  get(id) {
    return OperatorService.get(`/cameras/models/${id}`);
  },
}

export default ModelsService;
